/** CPF check-digit validation — the single shared rule (DriverDrawer schema and Setup Guide forms). */
export const isValidCPF = (cpf: string): boolean => {
  const cleaned = cpf.replace(/[^\d]/g, '');
  if (cleaned.length !== 11 || /^(\d)\1{10}$/.test(cleaned)) return false;

  const calculateCheckDigit = (factor: number): number => {
    const sum = Array.from(cleaned.slice(0, factor - 1)).reduce((acc, curr, index) => acc + Number.parseInt(curr, 10) * (factor - index), 0);
    const checkDigit = 11 - (sum % 11);
    return checkDigit >= 10 ? 0 : checkDigit;
  };

  return Number.parseInt(cleaned.charAt(9), 10) === calculateCheckDigit(10) && Number.parseInt(cleaned.charAt(10), 10) === calculateCheckDigit(11);
};

/** Strips CPF punctuation for payloads/duplicate comparisons. */
export const cleanCPF = (cpf: string): string => cpf.replace(/[^\d]/g, '').trim();
